import { Diagnostic } from "@siteimprove/alfa-act";
import { Err, Ok } from "@siteimprove/alfa-result";
import { expectation } from "../act/expectation.js";
import { Question } from "../act/question.js";
export function videoDescriptionTrackAccurate(target) {
    return {
        1: Question.of("track-describes-video", target).map((trackDescribesVideo) => expectation(trackDescribesVideo, () => Outcomes.HasDescriptionTrack, () => Outcomes.HasNoDescriptionTrack)),
    };
}
/**
 * @public
 */
export var Outcomes;
(function (Outcomes) {
    Outcomes.HasDescriptionTrack = Ok.of(Diagnostic.of(`The \`<video>\` element has a track that describes its visual information
    in the language of the \`<video>\` element or the page`));
    Outcomes.HasNoDescriptionTrack = Err.of(Diagnostic.of(`The \`<video>\` element does not have a track that describes its visual
    information in the language of the \`<video>\` element or the page`));
})(Outcomes || (Outcomes = {}));
//# sourceMappingURL=video-description-track-accurate.js.map